<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_cart" src="@/assets/images/icon_cart_blue.png" alt=""/>
        我的购物车
        <span class="sp2" style="margin-top: 2px">
<!--          <span v-if="this.checkedOptions.length > 0 && this.checkedOptions[0].baseConversionRate == null">-->
<!--            (购物车商品数量合计：{{totalTun}}-->
<!--          </span>-->
<!--          <span v-else>-->
<!--            (购物车商品数量合计：{{totalTun}}-->
<!--          </span>-->
          <span>
            ( 购物车商品数量合计：{{totalTun}}
          </span>
          <span v-if="isShowPrice === '1'">
            ，金额合计：{{totalAmt}}元
          </span>)
        </span>
      </span>

      <el-steps :active="2" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 产品选择" icon="el-icon-thumb"></el-step>
        <el-step title="2 购物车确认" icon="el-icon-shopping-cart-full"></el-step>
        <el-step title="3 完善订单信息" icon="el-icon-edit"></el-step>
        <el-step title="4 提交完成订单" icon="el-icon-document-checked"></el-step>
      </el-steps>

      <div v-if="isShowPrice === '1' && currentUser.userType === 1">
        <span style="color: red">*</span>
        <span style="margin-left: 5px">提货人：
          <el-select v-model="selectedCustomer"
                     @change="queryPrices"
                     :disabled="changeLoading"
                     placeholder="请选择"
                     size="small"
                     style="margin-top: 20px"
                     filterable
                     :filter-method="dataFilter"
                     ref="select"
                     :clearable="showClose"
                     @blur.native.capture="onblur"
                     @hook:mounted="cancelReadOnly"
                     @visible-change="cancelReadOnly">
            <el-option
              v-for="item in customerOption"
              :key="item.id"
              :label="item.name+' & '+item.number"
              :value="item.id">
            </el-option>
          </el-select>
        </span>
        <span style="font-size: smaller;color: rgb(143, 143, 143)">（选择提货人后展示价格）</span>
      </div>

      <el-checkbox-group v-model="checkedItems" @change="handleCheckedItemsChange" style="margin-top: 10px">
        <el-table :data="cartList"
                  style="width: 100%;"
                  border
                  v-loading="changeLoading"
                  element-loading-text="价格信息加载中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.3)">
          <el-table-column label="全选" min-width="5%">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row" :key="scope.row.goodsCode"><br></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="商品明细" min-width="35%">
            <template slot-scope="scope">
              <div style="display: flex">
                <div style="display: flex">
<!--                  <img class="bus_default" src="@/assets/images/simple.jpg" style="width: 85px;" alt=""/>-->
                  <img class="simple" v-if="scope.row.headUri != null" :src="scope.row.headUri" alt=""/>
                  <img class="simple" v-else :src="'https://minio.godaji.com/minio/osp/'+scope.row.goodsCode+'.jpg'" onerror="this.src='https://minio.godaji.com/minio/osp/simple.jpg';this.onerror=null;" style="width: 85px;height: 85px" alt=""/>
                </div>
                <div style="margin-top: 0;margin-left: 10px">
                  <span class="sp3" style="color: rgb(239, 51, 69)">代号：{{scope.row.goodsAlias}}</span><br>
                  <span class="sp4">名称：{{ scope.row.goodsName }}</span>
                  <span class="sp4" style="margin-left: 20px">规格：{{scope.row.goodsRule}}</span><br>
                  <span class="sp4">编码：{{ scope.row.goodsCode }}</span><br>
                  <span class="sp4" v-if="isShowPrice === '1'">净价：
                    <span style="color: red;font-weight: bold">{{priceList[scope.$index].price}}</span>
                    元/{{scope.row.baseUnitName}}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数量" min-width="15%">
            <template slot-scope="scope">
              <span v-if="scope.row.baseConversionRate == null">
                <span>{{ scope.row.baseUnitName.length === 2 ? scope.row.baseUnitName : scope.row.baseUnitName+'数' }}：</span>
                <el-input-number size="small" v-model="scope.row.weight" :min="0.001" @change="changeDun(scope.$index)"></el-input-number>
              </span>
              <span v-else>
                <span>{{ scope.row.baseUnitName.length === 2 ? scope.row.baseUnitName : scope.row.baseUnitName+'数' }}：</span>
                <el-input-number size="small" v-model="scope.row.weight" :min="1" :step="scope.row.baseConversionRate" @change="changeSale(scope.$index)"></el-input-number>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="辅助数量" min-width="15%">
            <template slot-scope="scope">
              <span v-if="scope.row.baseConversionRate == null">
                <span>包数：</span>
                <el-input-number v-if="scope.row.amount === 0" size="small" v-model="scope.row.amount" :min="0" @change="changeAmt(scope.$index)" disabled></el-input-number>
                <el-input-number v-if="scope.row.amount !== 0" size="small" v-model="scope.row.amount" :min="1" @change="changeAmt(scope.$index)"></el-input-number>
              </span>
              <span v-else>
                <span>{{scope.row.assistUnitName.length === 2 ? scope.row.assistUnitName : scope.row.assistUnitName+'数'}}：</span>
                <el-input-number size="small" v-model="scope.row.amount" :min="1" @change="changeAss(scope.$index)"></el-input-number>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="15%">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="handleFavorite(scope.row)">移入收藏夹</el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <div class="footer">
        <el-checkbox class="ck" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled="changeLoading"></el-checkbox>
        <span class="sp6">全选</span>
        <el-button class="but6" size="mini" @click="batchFavorite" :disabled="changeLoading">
          <span class="sp5">移入收藏夹</span>
        </el-button>
        <el-button class="but6" size="mini" @click="batchDelete" :disabled="changeLoading">
          <span class="sp5" >删除</span>
        </el-button>
        <el-button class="but6 settle" size="mini" @click="toOrder" :disabled="changeLoading">
          <span class="sp5">结算</span>
        </el-button>
        <span class="sp7" v-if="isShowPrice === '1'">结算金额：
          <span>{{selectedAmt}}</span>
          元</span>
<!--        <span class="sp7" v-if="this.checkedOptions.length > 0 && this.checkedOptions[0].baseConversionRate == null">共计：{{selectedDun}}吨</span>-->
<!--        <span class="sp7" v-else>数量合计：{{selectedDun}}</span>-->
        <span class="sp7">数量合计：{{selectedDun}}</span>
        <span class="sp7">已选商品：{{selectedItems}}件</span>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import {getCart, removeByCode, saveCart} from "../../../api/system/cart";
import {saveFavorites} from "../../../api/system/favorites";
import {queryPrices} from "../../../api/system/price";
import {queryCustomerListById, queryPersonSaleInfoById} from "../../../api/system/person";
import {queryCustomerSaleInfoById} from "../../../api/system/customer";

export default {
  name: "index",
  data(){
    return{
      currentUser:{},
      saleOrgId:'',
      saleOrgName:'',
      totalTun:0,//总数量
      cartList:[],
      cartTotalCount:'',
      checkAll:false,
      isIndeterminate: false,
      checkedItems:[],
      checkedOptions:[],
      disabled:false,
      goodList:[],
      isShowPrice: '0',//是否展示价格
      customerList:[],
      customerOption:[],
      selectedCustomer:'',
      priceList:[],
      totalAmt:'0',//总金额
      selectedItems:0,//结算物料数量
      selectedDun:0,//结算数量
      selectedAmt:'0',//结算金额
      changeLoading:false,
      showClose:false
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    //获取购物车列表
    this.getList()
    //获取用户销售资料
    this.getUserSaleInfo()
  },
  methods:{
    changeCompany(){
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    //获取用户权限（是否展示价格）
    getUserSaleInfo(){
      let param = {}
      param.saleOrgId = this.saleOrgId
      if(this.currentUser.userType === 1){
        param.personNumber = this.currentUser.username
        queryPersonSaleInfoById(param).then(res => {
          this.isShowPrice = res.data[0].isShowPrice
          // console.log("展示价格："+this.isShowPrice)
          if(this.isShowPrice === '1'){
            // console.log('获取客户：')
            this.queryCustomer()
          }
        }).catch({

        })
      }else if(this.currentUser.userType === 2){
        param.customerNumber = this.currentUser.username
        queryCustomerSaleInfoById(param).then(res => {
          // console.log(this.currentUser.customer.id)
          //客户不展示价格 250110
          // this.isShowPrice = res.data[0].isShowPrice
          // console.log("展示价格："+this.isShowPrice)
          // this.selectedCustomer = this.currentUser.customer.id
          // if(this.isShowPrice === '1'){
          //   this.queryPrices()
          // }
        }).catch({

        })
      }
    },
    //业务员查询客户 展示客户价格用
    queryCustomer(){
      let param = {};
      let saleOrgList = [{id:this.saleOrgId}]
      param.number = this.currentUser.username
      param.orgSaleList = saleOrgList
      queryCustomerListById(param).then(res => {
        if(res.code === 200){
          this.customerList = res.data
          this.customerOption = res.data
          // console.log(this.customerList)
        }else{
          this.$modal.msgError("获取您的客户失败，请联系营业室进行维护")
        }
      });
    },

    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customerOption = this.customerList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase()) || !!~item.number.indexOf(val) || !!~item.number.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customerOption = this.customerList;
      }
    },

    //查询价格，需要权限
    queryPrices(){
      // console.log('查询价格：')
      if(this.selectedCustomer === ''){
        for(let i = 0; i < this.priceList.length; i++){
          this.priceList[i].price = 0
        }
        return
      }
      if( this.goodList.length === 0){
        return
      }
      this.changeLoading = true
      let param = {}
      param.saleOrgId = this.saleOrgId;
      param.customerId = this.selectedCustomer
      param.materialIds = []
      for (let i = 0;i<this.goodList.length;i++){
        param.materialIds.push(this.goodList[i])
      }
      // console.log(this.goodList)
      queryPrices(param).then(res => {
        if(res.code === 200){
          // console.log(res.data)
          this.priceList = res.data
          //更新价格
          this.updatePrice()
          //计算总金额
          this.sumTotalAmt()
          //计算结算金额
          this.sumSelectedAmt()
        }
        this.changeLoading = false
      }).catch(()=>{
        this.$modal.msgError("获取物料价格失败,请重试")
        this.changeLoading = false
      });
    },
    // 获取购物车列表
    getList() {
      let queryParams = []
      queryParams.push(this.saleOrgId)
      // console.log(queryParams)
      getCart(queryParams).then(res =>{
        // console.log(res)
        //初始化数据
        this.totalTun = 0
        this.cartTotalCount = 0
        this.cartList = []
        this.goodList = []
        this.checkedOptions = []
        for(let i in res.data){
          for(let j in res.data[i].cartList) {
            //初始化数据
            let goods = {};
            goods.amount = res.data[i].cartList[j].amount;
            goods.goodsAlias = res.data[i].cartList[j].goodsAlias;
            goods.goodsCode = res.data[i].cartList[j].goodsCode;
            goods.goodsId = res.data[i].cartList[j].goodsId;
            goods.goodsName = res.data[i].cartList[j].goodsName;
            goods.goodsRule = res.data[i].cartList[j].goodsRule;
            goods.logo = res.data[i].cartList[j].logo;
            goods.orgSaleId = res.data[i].orgSaleId;
            goods.weight = res.data[i].cartList[j].weight;
            goods.goodsSpec = res.data[i].cartList[j].goodsSpec;
            goods.headUri = res.data[i].cartList[j].headUri;
            goods.baseConversionRate = res.data[i].cartList[j].baseConversionRate
            goods.assistUnitId = res.data[i].cartList[j].assistUnitId
            goods.assistUnitName = res.data[i].cartList[j].assistUnitName
            goods.baseUnitId = res.data[i].cartList[j].baseUnitId
            goods.baseUnitName = res.data[i].cartList[j].baseUnitName

            this.goodList.push(res.data[i].cartList[j].goodsId)
            this.cartList.push(goods);
            this.priceList.push({'price':'0'})
            this.cartTotalCount++;
            this.totalTun = this.floatAdd(this.totalTun,goods.weight)
            this.checkedOptions.push(goods)
          }
        }
      });
    },
    //吨改变
    changeDun (e) {
      if(this.cartList[e].goodsSpec !== '0' && this.cartList[e].goodsSpec !== null){
        let res = 0
        if(this.cartList[e].baseUnitName === '公斤'){
          res = this.floatDivision(this.cartList[e].weight, this.cartList[e].goodsSpec)
        }else{
          res = this.floatDivision(this.floatMul(this.cartList[e].weight,1000), this.cartList[e].goodsSpec)
        }
        if(typeof res === 'number' && res%1 === 0){
          this.cartList[e].amount = res
          this.saveCart(this.cartList[e])

          //计算总数量
          this.sumTotalTun();
          //计算结算数量
          this.sumSelectedTun();
          if(this.isShowPrice === '1'){
            //计算总金额
            this.sumTotalAmt();
            //计算结算金额
            this.sumSelectedAmt();
          }

        }else{
          //向上取整
          this.cartList[e].amount = Math.ceil(res)
          if(this.cartList[e].baseUnitName === '公斤'){
            this.saveCart(this.cartList[e])
          }else{
            this.changeAmt(e)
          }
        }
      } else {
        this.saveCart(this.cartList[e])
        //计算总数量
        this.sumTotalTun();
        //计算结算数量
        this.sumSelectedTun();
        if(this.isShowPrice === '1'){
          //计算总金额
          this.sumTotalAmt();
          //计算结算金额
          this.sumSelectedAmt();
        }
      }
    },
    changeAmt (e) {
      if(this.cartList[e].baseUnitName === '公斤'){
        this.cartList[e].weight = this.floatMul(this.cartList[e].amount, this.cartList[e].goodsSpec)
      }else{
        this.cartList[e].weight = this.floatDivision(this.floatMul(this.cartList[e].amount, this.cartList[e].goodsSpec),1000)
      }
      this.saveCart(this.cartList[e])
      //计算总数量
      this.sumTotalTun();
      //计算结算数量
      this.sumSelectedTun();
      if(this.isShowPrice === '1'){
        //计算总金额
        this.sumTotalAmt();
        //计算结算金额
        this.sumSelectedAmt();
      }
    },
    //销售数量改变
    changeSale (e) {
      let res = this.floatDivision(this.cartList[e].weight, this.cartList[e].baseConversionRate)
      if(typeof res === 'number' && res%1 === 0){
        this.cartList[e].amount = res
        this.saveCart(this.cartList[e])

        //计算总数量
        this.sumTotalTun();
        //计算结算数量
        this.sumSelectedTun();
        if(this.isShowPrice === '1'){
          //计算总金额
          this.sumTotalAmt();
          //计算结算金额
          this.sumSelectedAmt();
        }

      }else{
        //向上取整
        this.cartList[e].amount = Math.ceil(res)
        this.changeAss(e)
      }
    },
    //辅助数量改变
    changeAss (e) {
      this.cartList[e].weight = this.floatMul(this.cartList[e].amount, this.cartList[e].baseConversionRate)
      this.saveCart(this.cartList[e])
      //计算总数量
      this.sumTotalTun();
      //计算结算数量
      this.sumSelectedTun();
      if(this.isShowPrice === '1'){
        //计算总金额
        this.sumTotalAmt();
        //计算结算金额
        this.sumSelectedAmt();
      }
    },
    //计算总数量
    sumTotalTun(){
      this.totalTun = 0;
      // console.log(this.cartList.length)
      for(let i=0;i<this.cartList.length;i++){
        this.totalTun = this.floatAdd(this.totalTun,this.cartList[i].weight)
      }
    },
    //计算总金额
    sumTotalAmt(){
      this.totalAmt = 0;
      for(let i=0;i<this.cartList.length;i++){
        // console.log('数量：'+this.cartList[i].weight)
        // console.log('价格：'+(this.cartList[i].price === undefined ? 0 : this.cartList[i].price))
        this.totalAmt = this.floatAdd(this.totalAmt,this.floatMul(this.cartList[i].price === undefined ? 0 : this.cartList[i].price,this.cartList[i].weight))
      }
    },
    //计算结算数量
    sumSelectedTun(){
      this.selectedDun = 0;
      for(let i=0;i<this.checkedItems.length;i++){
        this.selectedDun = this.floatAdd(this.selectedDun,this.checkedItems[i].weight)
      }
    },
    //计算结算金额
    sumSelectedAmt(){
      if(this.selectedCustomer === ''){return}
      this.selectedAmt = 0;
      for(let i=0;i<this.checkedItems.length;i++){
        // console.log('数量：'+this.checkedItems[i].weight)
        // console.log('价格：'+(this.checkedItems[i].price === undefined ? 0 : this.checkedItems[i].price))
        this.selectedAmt = this.floatAdd(this.selectedAmt,this.floatMul(this.checkedItems[i].weight,this.checkedItems[i].price === undefined ? 0 : this.checkedItems[i].price))
      }
    },
    //删除商品
    handleDelete(index){
      this.$confirm("确定要删除此商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let goods = {};let cart = [];
        goods.goodsCode = this.cartList[index].goodsCode;
        goods.orgSaleId = this.saleOrgId;
        cart.push(goods)
        // console.log(cart)
        removeByCode(cart).then(res=>{
          if (res.code === 200) {
            this.$modal.msgSuccess("删除成功!")
            this.cartList.splice(index, 1)
            this.priceList.splice(index, 1)
            this.checkedOptions.splice(index, 1)
            this.selectedItems = this.checkedItems.length
            //更新价格
            this.updatePrice()
            //计算总数量
            this.sumTotalTun();
            //计算结算数量
            this.sumSelectedTun();
            if(this.isShowPrice === '1'){
              //计算总金额
              this.sumTotalAmt();
              //计算结算金额
              this.sumSelectedAmt();
            }
          } else {
            this.$modal.msgError("删除失败，请重试")
          }
        }).catch((e) => {
          console.log(e);
        });

      }).catch(() => {

      });
    },
    //批量删除商品
    batchDelete(){
      if(this.checkedItems.length === 0){
        this.$modal.msg("请选择需要删除的商品")
        return
      }
      let idList = []
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let cart = [];
        // console.log(this.checkedItems)
        // console.log(this.cartList)
        for(let i = 0; i < this.checkedItems.length; i++){
          let goods = {};
          goods.goodsCode = this.checkedItems[i].goodsCode;
          goods.orgSaleId = this.saleOrgId;
          cart.push(goods)

          for(let j = 0; j < this.cartList.length; j++){
            if(this.cartList[j].goodsCode === this.checkedItems[i].goodsCode){
              idList.push(j)
              break;
            }
          }
        }

        removeByCode(cart).then(res=>{
          if (res.code === 200) {
            this.$modal.msgSuccess("删除成功!")

            //排序，防止删除错误
            idList = idList.sort(function (a, b) {
              return b - a;
            });
            // console.log(idList)
            for(let i = 0; i < idList.length; i++){
              this.cartList.splice(idList[i], 1)
              this.priceList.splice(idList[i], 1)
              this.checkedOptions.splice(idList[i], 1)
              //更新价格
              this.updatePrice();
            }
            this.checkAll = false
            this.isIndeterminate = false
            this.selectedItems = 0
            this.selectedDun = 0
            this.selectedAmt = 0
            this.checkedItems = []

            //计算总数量
            this.sumTotalTun();
            //计算结算数量
            this.sumSelectedTun();
            if(this.isShowPrice === '1'){
              //计算总金额
              this.sumTotalAmt();
              //计算结算金额
              this.sumSelectedAmt();
            }
          } else {
            this.$modal.msgError("删除失败，请重试")
          }
        }).catch((e) => {
          console.log(e);
        });
      }).catch(() => {

      });
    },
    //更新价格
    updatePrice(){
      for(let i = 0; i < this.priceList.length; i++){
        this.cartList[i].price = this.priceList[i].price
      }
    },
    //加入收藏夹
    handleFavorite(row) {
      let goods = {}
      goods.goodsId = row.goodsId;
      goods.goodsCode = row.goodsCode;
      goods.goodsName = row.goodsName;
      goods.goodsRule = row.goodsRule;
      goods.goodsAlias = row.goodsAlias;
      goods.goodsSpec = row.goodsSpec;
      goods.logo = row.logo;
      goods.headUri = row.headUri;
      goods.orgSaleId = row.orgSaleId;
      goods.baseConversionRate = row.baseConversionRate
      goods.assistUnitId = row.assistUnitId
      goods.assistUnitName = row.assistUnitName
      goods.baseUnitId = row.baseUnitId
      goods.baseUnitName = row.baseUnitName

      let goodsList = [];
      goodsList.push(goods)
      saveFavorites(goodsList).then(res => {
        if(res.code === 200){
          this.$modal.msgSuccess("添加到收藏夹成功!")
        }else {
          this.$modal.msgError("添加到收藏夹失败!")
        }
      })
    },
    //批量加入收藏夹
    batchFavorite() {
      if(this.selectedItems === 0){
        this.$modal.msg("请选择需要加入收藏夹的商品")
        return
      }
      let goodsList = [];
      for(let i = 0; i < this.checkedItems.length; i++){
        let goods = {}
        goods.goodsId = this.checkedItems[i].goodsId;
        goods.goodsCode = this.checkedItems[i].goodsCode;
        goods.goodsName = this.checkedItems[i].goodsName;
        goods.goodsRule = this.checkedItems[i].goodsRule;
        goods.goodsAlias = this.checkedItems[i].goodsAlias;
        goods.goodsSpec = this.checkedItems[i].goodsSpec;
        goods.logo = this.checkedItems[i].logo;
        goods.headUri = this.checkedItems[i].headUri;
        goods.orgSaleId = this.checkedItems[i].orgSaleId;
        goods.baseConversionRate = this.checkedItems[i].baseConversionRate
        goods.assistUnitId = this.checkedItems[i].assistUnitId
        goods.assistUnitName = this.checkedItems[i].assistUnitName
        goods.baseUnitId = this.checkedItems[i].baseUnitId
        goods.baseUnitName = this.checkedItems[i].baseUnitName
        goodsList.push(goods)
      }

      saveFavorites(goodsList).then(res => {
        if(res.code === 200){
          this.$modal.msgSuccess("添加到收藏夹成功!")
        }else {
          this.$modal.msgError("添加到收藏夹失败!")
        }
      })
    },
    //全选
    handleCheckAllChange(val) {
      this.checkedItems = val ? this.checkedOptions : [];
      this.isIndeterminate = false;
      this.selectedItems = this.checkedItems.length
      this.sumSelectedTun()
      if(this.isShowPrice === '1'){
        this.sumSelectedAmt()
      }
    },
    //单选
    handleCheckedItemsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cartTotalCount;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cartTotalCount;
      this.selectedItems = checkedCount
      this.sumSelectedTun()
      if(this.isShowPrice === '1'){
        this.sumSelectedAmt()
      }
    },
    saveCart(goods){
      let cartList = {}
      cartList.goodsId=goods.goodsId;
      cartList.goodsCode=goods.goodsCode;
      cartList.goodsName=goods.goodsName;
      cartList.goodsRule=goods.goodsRule;
      cartList.goodsAlias=goods.goodsAlias;
      cartList.logo = goods.logo;
      cartList.goodsSpec=goods.goodsSpec;
      cartList.weight=goods.weight;
      cartList.amount=goods.amount;
      cartList.headUri=goods.headUri;
      cartList.orgSaleId = this.saleOrgId;
      cartList.baseConversionRate = goods.baseConversionRate;
      cartList.assistUnitId = goods.assistUnitId;
      cartList.assistUnitName = goods.assistUnitName;
      cartList.baseUnitId = goods.baseUnitId;
      cartList.baseUnitName = goods.baseUnitName;

      let goodsList = [];
      goodsList.push(cartList)
      saveCart(goodsList).then(res => {
        if(res.code === 200){
          // console.log('数量修改成功')
          this.sumTotalTun()
          if(this.isShowPrice === '1'){
            this.sumTotalAmt()
          }
        }else{
          this.$modal.msgError("操作失败，请重试")
        }
      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    //小数加法
    floatAdd(a,b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, Math.max(m, n)); //将数字转换为整数的最大倍数
      return (this.floatMul(a, maxInt) + this.floatMul(b, maxInt)) / maxInt;
    },
    //小数乘法
    floatMul(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, m + n); //将数字转换为整数的最大倍数
      return Number(d.replace(".", "")) * Number(e.replace(".", "")) / maxInt;
    },
    //小数除法
    floatDivision(a, b){
      let m = 0, n = 0,              //记录a，b的小数位数
        d = a + "",                  //字符串化
        e = b + "";
      try {
        m = (d.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      try {
        n = (e.split(".")[1] || '').length;
      } catch (error) {
        console.log(error)
      }
      let maxInt = Math.pow(10, Math.max(n, m)); //将数字转换为整数的最大倍数
      let aInt = this.floatMul(a, maxInt);
      let bInt = this.floatMul(b, maxInt);
      return aInt / bInt;
    },
    toOrder(){
      // console.log(this.checkedItems)
      if(this.isShowPrice ==='1' && this.selectedCustomer === ''){
        this.$modal.msg("请先选择提货人")
        return
      }
      if(this.selectedItems === 0){
        this.$modal.msg("请选择需要结算的商品")
        return
      }
      if(this.selectedDun === 0){
        this.$modal.msgError("商品数量为0，结算失败")
        return
      }
      this.$router.push({ name: "Order",params: {'goodsList':JSON.stringify(this.checkedItems),'selectedCustomer':this.selectedCustomer}});
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
    margin-top: -10px;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .but6{
    background: white;
    border: 0;
  }
  .sp2{
    color: rgb(239, 51, 69);
    font-size: 14px;
  }
  .sp3{
    font-weight: bold;
  }
  .sp4{
    color: rgb(143, 143, 143);
  }
  .footer{
    height: 48px;
    background: linear-gradient(180.00deg, rgba(239,50,68,1) 0%,rgba(246,88,104,1) 100%);
    line-height: 48px;
  }
  .sp5{
    color: rgb(240, 55, 72);
    letter-spacing: 1px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
  .sp6{
    color: white;
    font-size: 14px;
    margin: 0 20px 0 10px;
  }
  .ck{
    margin-left: 10px;
  }
  .settle{
    float: right;
    border-radius: 5px;
    margin-top: 9px;
    margin-right: 30px;
    width: 100px;
  }
  .sp7{
    float: right;
    color: white;
    font-size: 14px;
    margin-right: 20px;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_cart{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 2px;
    margin-left: 2px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
  .simple{
    width: 80px;
  }
</style>
